<template>  
  <div class="dilution">
    <div class="section-image">
      <b-container>
        <b-row>
            <b-col>
              <h1 class="text-center section-name">SPÄDNING</h1>
            </b-col>
        </b-row>
      </b-container>
      <b-container>
        <b-row>
          <b-col>
            <b-form-input v-model="search" type="text" placeholder="Sök läkemedel" class="drug-search"></b-form-input>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <b-container class="view-container">
      <b-row>
        <b-col>
          <div v-if="user.isAdmin">
            <hr>
            <div class="text-center">
              <mu-raised-button class="demo-raised-button" label="Lägg till spädningsläkemedel" icon="add" primary @click="showCreateDialog"/>
            </div>
            <hr>
          </div>
          <ul class="drug-list">
            <li v-for="drug in filteredDrugList" v-bind:key="drug.id">
              <b-row>
                <b-col cols="1" class="text-right">
                  <i class="fa fa-2x fa-angle-right"></i>
                </b-col>
                <b-col cols="10">
              <router-link :to="'/spadning/' + drug.id">
              <h4 class="text-uppercase break-word" :class="!drug.isPublished ? 'text-muted' : ''">
                {{ drug.name }} <mu-icon v-if="!drug.isPublished" value="visibility_off" color="#7e57c2"/>
              </h4> 
              <span class="text-lowercase" :class="!drug.isPublished ? 'text-muted' : ''">({{ drug.substance }})</span>
              </router-link>
                </b-col>
              </b-row>
              </li>
          </ul>
        </b-col>
      </b-row>
    </b-container>
    <mu-dialog :open="showDialog" title="Lägg till spädningsläkemedel">
      <create-dilution @close="closeDialog"></create-dilution>
    </mu-dialog>
  </div>
</template>

<script>
import { getAll } from '../store/actions'
import { sortBy, includes, toLower } from 'lodash'
import { clickTracker } from '@/services/helpers'
import CreateDilution from '../components/CreateDilution'

export default {
  name: 'Dilution',
  data () {
    return {
      search: '',
      showDialog: false
    }
  },
  mounted () {
    getAll(this.$store)
    clickTracker('keyDilutionList')
  },
  computed: {
    filteredDrugList () {
      return this.sortedDrugList.filter(drug => {
        return includes(toLower(drug.name) || '', toLower(this.search) || '') ||
          includes(toLower(drug.substance) || '', toLower(this.search) || '')
      })
    },
    sortedDrugList () {
      return sortBy(this.drugList, drug => toLower(drug.name) || '')
    },
    drugList () {
      return this.$store.state.dilutions
    },
    user () {
      return this.$store.state.user
    }
  },
  methods: {
    showCreateDialog () {
      this.showDialog = true
    },
    closeDialog () {
      this.showDialog = false
    }
  },
  components: {
    'create-dilution': CreateDilution
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h1, h2 {
  font-weight: normal;
}

ul {
  padding-left: 10px;
}

ul li {
  list-style: none;
}

.drug-search {
  margin: 20px 0;
  padding: 10px;
}

.drug-list {
  h4 {
    margin-top: 1rem;
    margin-bottom: 0;
  }
  i.fa {
    color: $orange;
    margin-top: 20px;
  }
}

.section-name {
  color: white;
  margin: 0;
  font-weight: bold;
  font-size: 25pt;
  text-shadow: 0 0 10px #888
}

.section-image {
  padding-top: 25px;
  top: 70px;
  z-index: -1;
  height: 170px;
  width: 100%;
  background-image: url('../assets/dilution-background.jpg');
  background-position-y: bottom;
  background-size: cover;
}

.view-container {
  padding-top: 0;
}

</style>
